/**
 * projectCreateRights.ts — WEB-1556.
 *
 * Одно место для правила «кто может завести проект» в кабинете.
 *
 * САМО право берётся общим источником роли в организации —
 * `useOrgRole().isOrgAdmin` (WEB-1417/WEB-562): владелец или администратор
 * ОРГАНИЗАЦИИ. Ровно это спрашивает сервер
 * (`backend/src/projects/services/projects.service.ts`, resolveOrgId), и
 * второй копии правила заводить нельзя. Здесь лежит только ТЕКСТ отказа,
 * чтобы оба места кнопки («Проекты» организации и баннер пустого кабинета)
 * говорили человеку одно и то же слово в слово.
 *
 * Формулировка ратифицирована в карточке WEB-1556; менять — только по
 * решению владельца продукта.
 */
import { pickStrings } from '@/i18n';
import { settingsStrings } from '@/i18n/dictionaries/settings';
/**
 * WEB-1874: текст переехал в словарь кабинета (`settings.createProjectDenied`),
 * здесь остался ОДИН вход для всех четырёх дверей. Это функция, а не
 * константа, ровно потому, что язык известен только в момент показа: у
 * константы значение застыло бы на языке, который был при загрузке модуля.
 */
export function createProjectDeniedHint(): string {
  return pickStrings(settingsStrings).createProjectDenied;
}
